import Rellax from 'rellax';

export default function (el) {
    new Rellax(el.querySelector('div'), { center: true }); // eslint-disable-line no-new
}
